module.exports = __webpack_public_path__ + "img/check-blue-16dp.3119ba39.svg";